import ScrollReveal from '../components/ScrollReveal';

const projects = [
  {
    category: 'Branding',
    title: 'Lumina Cosmetics',
    description: 'Rediseño completo de marca para línea de cosméticos premium.',
    image: 'https://images.unsplash.com/photo-1596462502278-27bfdc403348?w=800&fit=crop',
  },
  {
    category: 'Diseño Web',
    title: 'TechFlow SaaS',
    description: 'Plataforma web para startup de tecnología con enfoque en UX.',
    image: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=800&fit=crop',
  },
  {
    category: 'Redes Sociales',
    title: 'Café Origen',
    description: 'Campaña integral en redes sociales para cadena de cafeterías artesanales.',
    image: 'https://images.unsplash.com/photo-1554118811-1e0d58224f24?w=800&fit=crop',
  },
  {
    category: 'Marketing Digital',
    title: 'UrbanFit Gym',
    description: 'Estrategia de marketing digital con incremento del 240% en leads.',
    image: 'https://images.unsplash.com/photo-1534438327276-14e5300c3a48?w=800&fit=crop',
  },
];

export default function Portfolio() {
  return (
    <div className="page">
      <section className="section">
        <div className="container">
          <ScrollReveal>
            <span className="section-label">Portafolio</span>
          </ScrollReveal>
          <ScrollReveal delay={0.1}>
            <h1 className="section-title">
              Proyectos que<br />
              <span className="gradient-text">hablan por sí solos.</span>
            </h1>
          </ScrollReveal>
          <ScrollReveal delay={0.2}>
            <p className="section-subtitle">
              Una selección de nuestros trabajos más recientes. Cada proyecto
              refleja nuestra dedicación a la excelencia y los resultados.
            </p>
          </ScrollReveal>

          <div className="portfolio-grid">
            {projects.map(({ category, title, description, image }, i) => (
              <ScrollReveal key={title} delay={i * 0.1}>
                <div className="portfolio-card">
                  <img
                    className="portfolio-card-bg"
                    src={image}
                    alt={title}
                  />
                  <div className="portfolio-card-content">
                    <div className="portfolio-category">{category}</div>
                    <h3>{title}</h3>
                    <p>{description}</p>
                  </div>
                </div>
              </ScrollReveal>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
